export const SET_EDIT_ROW_SECTIONS_MODAL_STATE = 'designer/SET_EDIT_ROW_SECTIONS_MODAL_STATE';
export const RESET_EDIT_ROW_FORM = 'designer/RESET_EDIT_ROW_FORM';


export const SET_EDIT_ROW_MAIN_DATA = 'designer/SET_EDIT_ROW_MAIN_DATA';
export const SET_ADDITIONAL_DESIGNER_DATA = 'designer/SET_ADDITIONAL_DESIGNER_DATA';
export const OPEN_DESIGNER_SIDEBAR = 'designer/OPEN_DESIGNER_SIDEBAR';
export const CLOSE_DESIGNER_SIDEBAR = 'designer/CLOSE_DESIGNER_SIDEBAR';

export const SET_MOUSE_COORDS = 'designer/SET_MOUSE_COORDS';
export const SET_DND_SECTION_ID = 'designer/SET_DND_SECTION_ID';
export const UPDATE_CURRENT_LAYOUT = 'designer/UPDATE_CURRENT_LAYOUT';
export const UPDATE_CURRENT_LAYOUT_LIST = 'designer/UPDATE_CURRENT_LAYOUT_LIST';
export const SET_PARENT_REFS = 'designer/SET_PARENT_REFS';
export const RESET_DND_SECTION_ID = 'designer/RESET_DND_SECTION_ID';

//unrelated fields

export const ADD_TO_UNRELATED_FIELDS = 'designer/ADD_TO_UNRELATED_FIELDS';
export const REMOVE_FROM_UNRELATED_FIELDS = 'designer/REMOVE_FROM_UNRELATED_FIELDS';
export const ADD_NEW_SECTION = 'designer/ADD_NEW_SECTION';

export const SET_ADD_NEW_SECTION_MODAL_STATE = 'designer/SET_ADD_NEW_SECTION_MODAL_STATE';

export const MOVE_ITEM_TO_SECTION = 'designer/MOVE_ITEM_TO_SECTION';

export const DELETE_SECTION = 'designer/DELETE_SECTION';
export const UPDATE_SECTION = 'designer/UPDATE_SECTION';
export const SET_SECTION_REORDER_MODAL_STATE = 'designer/SET_SECTION_REORDER_MODAL_STATE';
export const SAVE_SECTIONS_ORDERING = 'design/SAVE_SECTIONS_ORDERING';
export const SET_CUSTOMISATION_MODAL_STATE = 'design/SET_CUSTOMISATION_MODAL_STATE';
export const SET_SEARCH_VALUE = 'design/SET_SEARCH_VALUE';

export const UPDATE_UNRELATED_FIELDS = 'design/UPDATE_UNRELATED_FIELDS';

export const REMOVE_POSTED_STATUS_FROM_RELATED_FIELDS = 'design/REMOVE_POSTED_STATUS_FROM_RELATED_FIELDS';

export const UPDATE_MODEL = 'design/REMOVE_POSTED_STATUS_FROM_RELATED_FIELDS';

export const UPDATE_DATA_IN_EDIT_MODE = 'design/UPDATE_DATA_IN_EDIT_MODE';